const Config = {
  apiKey: "AIzaSyAKiv_3g_TTuyJo6XxG_zZtLjXYJbxtacE",
  authDomain: "careers.alphanumericideas.com",
  projectId: "alphanumeric-career",
  storageBucket: "alphanumeric-career.appspot.com",
  messagingSenderId: "958776399971",
  appId: "1:958776399971:web:5983f98b48aedb1e18c056",
};
export default Config;
